import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Button } from "app-core";

import ButtonType = Data.Core.ButtonType;

@Component({
	selector: 'app-product-presentation-doctors',
	templateUrl: './product-presentation-doctors.component.html',
	styleUrls: ['./product-presentation-doctors.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductPresentationDoctorsComponent {
	public downloadButton: Button = new Button({
		label: 'Download',
		type: ButtonType.button,
		action: () => {
			const link = document.createElement('a');
			link.href = this.productDemoURL;
			link.download = `https://www.doctors.arogyaline.com/assets/ArogyaLine - Doctors.pptx`; // Optional: suggest filename
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	});
	public loading: boolean = true;
	public productDemoURL: string = `https://www.doctors.arogyaline.com/assets/ArogyaLine - Doctors.pptx`;

	public ngAfterViewInit(): void {
		const iframe = document.querySelector('iframe');
		if (iframe) {
			iframe!.onload = () => {
				const iframeDoc = iframe?.contentDocument || iframe?.contentWindow?.document;
				if (iframeDoc) {
					const style = iframeDoc.createElement('style');
					style.textContent = `[role="document"] { padding-top: 5em; }`;
					iframeDoc.head.appendChild(style);
				}
			};
		}
	}

	public onDocLoaded(): void {
		this.loading = false;
	}
}
